/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseContainerFragment} from '@amblique/contentful/app/contentful/fragments/container/base-container.fragment';
import {BaseAccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/base-accordion.fragment';
import {BaseAccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/base-accordion-panel.fragment';
import {BaseActionLinksFragment} from '@amblique/contentful/app/contentful/fragments/action-links/base-action-links.fragment';
import {BaseBlogFragment} from '@amblique/contentful/app/contentful/fragments/blog/base-blog.fragment';
import {BaseCardFragment} from '@amblique/contentful/app/contentful/fragments/card/base-card.fragment';
import {BaseCarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel/base-carousel.fragment';
import {BaseEmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel/base-embed-panel.fragment';
import {BaseFeatureListFragment} from '@amblique/contentful/app/contentful/fragments/feature-list/base-feature-list.fragment';
import {BaseHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/base-hero-banner.fragment';
import {BaseIconSetFragment} from '@amblique/contentful/app/contentful/fragments/icon-set/base-icon-set.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';
import {BaseMediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel/base-media-carousel.fragment';
import {BaseProductDetailFragment} from '@amblique/contentful/app/contentful/fragments/product-detail/base-product-detail.fragment';
import {BaseProductListingFragment} from '@amblique/contentful/app/contentful/fragments/product-listing/base-product-listing.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseSectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/base-section-panel.fragment';
import {BaseSplitPanelFragment} from '@amblique/contentful/app/contentful/fragments/split-panel/base-split-panel.fragment';
import {BaseUgcBlockFragment} from '@amblique/contentful/app/contentful/fragments/ugc-block/base-ugc-block.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const ContainerFragment = gql`
  ${BaseAccordionFragment}
  ${BaseAccordionPanelFragment}
  ${BaseActionLinksFragment}
  ${BaseBlogFragment}
  ${BaseCardFragment}
  ${BaseCarouselFragment}
  ${BaseContainerFragment}
  ${BaseEmbedPanelFragment}
  ${BaseFeatureListFragment}
  ${BaseHeroBannerFragment}
  ${BaseIconSetFragment}
  ${BaseImageFragment}
  ${BaseLinkFragment}
  ${BaseMediaCarouselFragment}
  ${BaseProductDetailFragment}
  ${BaseProductListingFragment}
  ${BaseRichTextBlockFragment}
  ${BaseSectionPanelFragment}
  ${BaseSplitPanelFragment}
  ${BaseUgcBlockFragment}
  ${BaseVideoFragment}

  fragment ContainerFragment on Container {
    ...BaseContainerFragment

    region1Collection {
      items {
        __typename
        ... on Accordion {
          ...BaseAccordionFragment
        }
        ... on AccordionPanel {
          ...BaseAccordionPanelFragment
        }
        ... on ActionLinks {
          ...BaseActionLinksFragment
        }
        ... on Blog {
          ...BaseBlogFragment
        }
        ... on Card {
          ...BaseCardFragment
        }
        ... on Carousel {
          ...BaseCarouselFragment
        }
        ... on EmbedPanel {
          ...BaseEmbedPanelFragment
        }
        ... on FeatureList {
          ...BaseFeatureListFragment
        }
        ... on HeroBanner {
          ...BaseHeroBannerFragment
        }
        ... on IconSet {
          ...BaseIconSetFragment
        }
        ... on Image {
          ...BaseImageFragment
        }
        ... on Link {
          ...BaseLinkFragment
        }
        ... on MediaCarousel {
          ...BaseMediaCarouselFragment
        }
        ... on ProductDetail {
          ...BaseProductDetailFragment
        }
        ... on ProductListing {
          ...BaseProductListingFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on SplitPanel {
          ...BaseSplitPanelFragment
        }
        ... on UgcBlock {
          ...BaseUgcBlockFragment
        }
        ... on Video {
          ...BaseVideoFragment
        }
      }
    }
  }
`;
